import { OfferReturn } from "@/api/offers";
import { Loading } from "@/components/Loading";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { ProductFromCookie } from "../type-product/productFromCookie";
import useSWR from "swr";
import api from "@/api";
import { MapProducts } from "@/api/products/mapProducts";
import { useNavigate } from "react-router-dom";
import { Plan } from "@/api/products";
import { sortFidelitiesByDDD } from "@/utils";

export function PersonalDataWithOfferCookie({ offer }: { offer: OfferReturn }) {
  const navigate = useNavigate();
  const [productFromCookie, setProductFromCookie] = useState<Plan>();
  const [working, setWorking] = useState(true);

  const { data: products, isLoading } = GetPlansFetch();

  useEffect(() => {
    if (products) {
      const _productFromCookie = products.find(
        (product) =>
          product.tim_id === offer.tim_id &&
          product.precos.find((price) => price.ddd === offer.ddd)
      ) as Plan;

      if (_productFromCookie?.fidelidades) {
        _productFromCookie.fidelidades = sortFidelitiesByDDD(
          _productFromCookie.fidelidades,
          offer.ddd
        );
      }

      if (_productFromCookie && offer.pacote_configuracoes) {
        _productFromCookie.pacote_configuracoes_id_substituto =
          offer.pacote_configuracoes.id;

        _productFromCookie.mostrarDedicado =
            offer.pacote_configuracoes.mostrar_bonus_dedicado;
        _productFromCookie.gbBonusDedicated = _productFromCookie.mostrarDedicado
            ? offer.pacote_configuracoes?.dedicated?.gb
            : 0;

        _productFromCookie.bonusPortabilidade =
          offer.pacote_configuracoes?.portability?.gb;

        _productFromCookie.mostrarPortabilidade =
          offer.pacote_configuracoes.mostrar_bonus_portabilidade;
        _productFromCookie.gbBonusPortabilidade =
          _productFromCookie.mostrarPortabilidade
            ? offer.pacote_configuracoes?.portability?.gb
            : 0;

        _productFromCookie.gbPromocional =
          offer.pacote_configuracoes?.flash_sale?.gb || 0;

        const portin = _productFromCookie.gbBonusPortabilidade ?? 0;
        const padrao = _productFromCookie.gbPadrao ?? 0;
        const flash = _productFromCookie.gbPromocional ?? 0;
        const dedicated = _productFromCookie.gbBonusDedicated ?? 0;

        _productFromCookie.gb = portin + padrao + flash + dedicated;
      }
      setProductFromCookie(_productFromCookie);
      setWorking(false);
    }
  }, [offer.ddd, offer.pacote_configuracoes, offer.tim_id, products]);

  if (isLoading || working) {
    return <Loading src="/tim_logo.svg" />;
  }

  if (offer) {
    if (!productFromCookie) {
      Cookies.remove("offer");
      navigate("/", { replace: true });
      return;
    }

    return (
      <ProductFromCookie productFromCookie={productFromCookie} offer={offer} />
    );
  }
}

export default PersonalDataWithOfferCookie;

export const GetPlansFetch = () => {
  const { data, mutate, isLoading, error } = useSWR(`getPlans_`, async () => {
    const { data } = await api.get(`/core/planos/`);

    return MapProducts(data);
  });

  return { data, mutate, isLoading, error };
};
